import GlobalLevel from './GlobalLevel';
class GlobalLevelList {
    levels = [];
    convertObjectsFromJson(levelJson) {
        const levelArray = [];
        levelJson.forEach((level) => {
            const tempLevel = new GlobalLevel(level);
            levelArray.push(tempLevel);
        });
        levelArray.sort((a, b) => (a.levelfrom > b.levelfrom) ? 1 : -1);
        this.levels = levelArray;
    }
}
export default GlobalLevelList;
